//Header Sticky
/* Header Scroll
--------------------------------------------- */

export function headerSticky() {
    let previousScroll = 0;
    window.addEventListener("scroll", headerScroll);

    function headerScroll() {
        const currentScroll = window.scrollY || document.documentElement.scrollTop;
        if (currentScroll > previousScroll) {
            document.querySelector("header.site-header.sticky").classList.add("scroll-down");
        } else {
            document.querySelector("header.site-header.sticky").classList.remove("scroll-down");
        }
        if (currentScroll > 0) {
            document.querySelector("header.site-header.sticky").classList.add("scrolled");
        } else {
            document.querySelector("header.site-header.sticky").classList.remove("scrolled");
        }
        previousScroll = currentScroll;
    }


    // Insert SVG caret down to menu items with children
    const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path></svg>`;

    const caretElements = document.querySelectorAll('.menu-item-has-children .caret');
    caretElements.forEach(caret => {
        // Check if SVG already exists to avoid duplication
        if (!caret.querySelector('svg')) {
            caret.innerHTML = svgContent;
        }
    });

    const caretGTranslateElements = document.querySelectorAll('.site-header .gtranslate_wrapper .glink.gt_switcher-popup');
    caretGTranslateElements.forEach(caret => {
        const svgElement = document.createElement('i');
        svgElement.classList.add('caret');
        svgElement.innerHTML = svgContent;
        caret.appendChild(svgElement);
    });

    /* BEGIN: Main Menu */
    const caretMainMenu = document.querySelectorAll('.main-menu .menu-item-has-children');
    caretMainMenu.forEach(menuItem => {
        const svgElement = document.createElement('i');
        svgElement.classList.add('caret');
        svgElement.innerHTML = svgContent;
        svgElement.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            menuItem.classList.toggle('expand');
        });
        menuItem.prepend(svgElement);
    });
    /* END: Main Menu */

    /* BEGIN: Sidebar Menu */
    const caretSidebarMenu = document.querySelectorAll('.sidebar-menu .menu-item-has-children');
    caretSidebarMenu.forEach(menuItem => {
        const svgElement = document.createElement('i');
        svgElement.classList.add('caret');
        svgElement.innerHTML = svgContent;

        const updateCaretHeight = () => {
            const menuLink = menuItem.querySelector(':scope > a') || menuItem.querySelector('a');
            const linkHeight = menuLink?.getBoundingClientRect().height;
            if (linkHeight) {
                svgElement.style.height = `${linkHeight}px`;
                svgElement.style.lineHeight = `${linkHeight}px`;
            }
        };

        svgElement.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            menuItem.classList.toggle('expand');
        });
        menuItem.appendChild(svgElement);
        updateCaretHeight();
        window.addEventListener('resize', updateCaretHeight);
    });
    /* END: Sidebar Menu */

    const hideGTranslateDropdown = () => {
        // const gtranslateWrapper = document.querySelector('.gtranslate_wrapper .gt_switcher-popup');
        const blackOverlay = document.querySelector('.gt_black_overlay');
        const whiteContent = document.querySelector('.gt_white_content');


        if (blackOverlay && blackOverlay.style.display === 'block') {
            blackOverlay.style.display = 'none';
        }
        if (whiteContent && whiteContent.style.display === 'block') {
            whiteContent.style.display = 'none';
        }
    };

    // GTranslate dropdown close on outside click
    document.addEventListener('click', function(event) {
        const gtranslateWrapper = document.querySelector('.gtranslate_wrapper .gt_switcher-popup');

        if (gtranslateWrapper && !gtranslateWrapper.contains(event.target)) {
            hideGTranslateDropdown();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            hideGTranslateDropdown();
        }
    });

    //Menu Toggle Mobile
    const menuToggle = document.querySelector('.menu-toggle');
    const menu = document.querySelector('.main-menu');

    if (menuToggle && menu) {
        menuToggle.addEventListener('click', () => {
            menuToggle.classList.toggle('active');
            menuToggle.closest('.site-header').classList.toggle('menu-expand');
        });
    }

    //Search form
    const toggleSearchButton = document.querySelector('.button-toggle-search');
    const headerSearchWrapper = document.querySelector('.header-search-wrapper');
    const searchField = headerSearchWrapper?.querySelector('.search-field');

    if (toggleSearchButton && headerSearchWrapper) {
        toggleSearchButton.addEventListener('click', (event) => {
            event.preventDefault();
            const isActive = headerSearchWrapper.classList.toggle('active');
            toggleSearchButton.classList.toggle('active', isActive);
            if (isActive && searchField) {
                searchField.focus();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && headerSearchWrapper.classList.contains('active')) {
                headerSearchWrapper.classList.remove('active');
                toggleSearchButton.classList.remove('active');
                if (searchField) {
                    searchField.blur();
                }
            }
        });

        document.addEventListener('click', (event) => {
            const clickedInsideSearch = headerSearchWrapper.contains(event.target);
            const clickedToggle = toggleSearchButton.contains(event.target);

            if (!clickedInsideSearch && !clickedToggle && headerSearchWrapper.classList.contains('active')) {
                headerSearchWrapper.classList.remove('active');
                toggleSearchButton.classList.remove('active');
                if (searchField) {
                    searchField.blur();
                }
            }
        });
    }
}
